import { render } from "./BBanner.vue?vue&type=template&id=0b47c455&scoped=true&ts=true"
import script from "./BBanner.vue?vue&type=script&lang=ts"
export * from "./BBanner.vue?vue&type=script&lang=ts"

import "./BBanner.vue?vue&type=style&index=0&id=0b47c455&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b47c455"]])

export default __exports__